import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { Button2 } from "@/components/UI2/atoms/Button";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { TextField2 } from "@/components/UI2/molecules/TextField";

import { addendumSchema, type AddendumFormValues } from "./schema";

type AddendumFormProps = {
  onCancel: () => void;
  onSubmit: (values: AddendumFormValues) => void;
};

export function AddendumForm({ onCancel, onSubmit }: AddendumFormProps) {
  const { control, formState, handleSubmit } = useForm<AddendumFormValues>({
    defaultValues: { addendum: "" },
    mode: "onChange",
    resolver: zodResolver(addendumSchema),
  });

  return (
    <form
      className="tw:flex tw:flex-col"
      onSubmit={handleSubmit(onSubmit)}
      {...getAutomationDataAttr("note-addendum-form")}
    >
      <Controller
        control={control}
        name="addendum"
        render={({ field, fieldState }) => (
          <TextField2
            description="Addendums will not be saved in drafts"
            errorMessage={fieldState.error?.message}
            isInvalid={!!fieldState.error}
            label=""
            mode="textarea"
            onChange={field.onChange}
            placeholder="Type Comment..."
            textAreaProps={{
              className: "tw:h-32",
              ...getAutomationDataAttr("note-addendum-comment"),
            }}
            value={field.value}
          />
        )}
      />

      <div className="tw:flex tw:items-end tw:justify-end tw:gap-4">
        <Button2 className="tw:mr-4 tw:min-w-40" onPress={onCancel} variant="secondary">
          Cancel
        </Button2>

        <Button2
          className="tw:mt-6 tw:min-w-40"
          isDisabled={!formState.isValid}
          type="submit"
          variant="primary"
          {...getAutomationDataAttr("note-addendum-save")}
        >
          Save
        </Button2>
      </div>
    </form>
  );
}
